/**
 * Tipos de contraste default
 *
 * @category Components
 */
export var Contrast;
(function (Contrast) {
    Contrast["default"] = "default";
    Contrast["light"] = "light";
    Contrast["dark"] = "dark";
})(Contrast || (Contrast = {}));
//# sourceMappingURL=general.types.js.map